import * as React from "react";
import "./Glossary.css";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";

export default function Glossary({isMobile}) {
  const [ShowMoreData, SetShowMoreData] = React.useState(false);

  const HandelshowMore = () => {
    SetShowMoreData(true);
    setButtonHidden(true);
  };
  const [buttonHidden, setButtonHidden] = React.useState(false);

  return (
    <>
      <div>
        <div className="Glossary-heading">
          <h3>Glossary</h3>
        </div>
        <div className="Glossary-card-outter">
          <div className="Glossary-card-Flex-containerNEW">
            <div className="Glossary-card-heading">
              <h1>A</h1>
            </div>
            <div className="Glossary-card-lastf1data">
              <div className="Glossary-inner-F1-score-flex">
                <div className="Glossary-inner-F1-heading">
                  <h3 className="agc-doc-mobile">Accuracy</h3>
                </div>
                <div className="Glossary-inner-F1-innerdata">
                  <p>
                    Shows how often a classification ML model is correct overall
                  </p>
                </div>
              </div>

              <div className="flex-alldaata">
                <div className="Glossary-card--heading">
                  <h3 className="agc-doc-mobile">Agency Document:</h3>
                </div>
                <div className="JOI-Score-css">
                  <p>
                    Refers to any official record, report, regulation, policy,
                    guideline, or other material produced, maintained, or issued
                    by a government agency. These documents are created to
                    support the agency’s operations, implement laws, communicate
                    policies, or provide transparency to the public. The term is
                    broad and varies by context, but here are key{" "}
                    <span
                      className="types-of-Agency-mobile"
                      style={{ fontWeight: "bold" }}
                    >
                      Types of Agency Documents:
                    </span>
                  </p>

                  <ul className="glossary-items-points">
                    <li>
                      <span
                        style={{ fontWeight: "bold" }}
                        className="comm-head-mobile-stl"
                      >
                        Regulations:
                      </span>{" "}
                      Rules or standards issued by agencies to enforce laws
                      (e.g., EPA regulations on emissions).
                    </li>
                    <li>
                      <span
                        style={{ fontWeight: "bold" }}
                        className="comm-head-mobile-stl"
                      >
                        Guidance Documents:
                      </span>{" "}
                      Non-binding recommendations or interpretations of laws or
                      regulations (e.g., FDA guidance on drug approvals).
                    </li>
                    <li>
                      <span
                        style={{ fontWeight: "bold" }}
                        className="comm-head-mobile-stl"
                      >
                        Reports:
                      </span>{" "}
                      Studies, findings, or data analyses (e.g., a CDC report on
                      public health trends).
                    </li>
                    <li>
                      <span
                        style={{ fontWeight: "bold" }}
                        className="comm-head-mobile-stl"
                      >
                        Policies and Procedures:
                      </span>{" "}
                      Internal or public-facing rules for agency operations
                      (e.g., IRS manuals for tax audits).
                    </li>
                    <li>
                      <span
                        style={{ fontWeight: "bold" }}
                        className="comm-head-mobile-stl"
                      >
                        Correspondence:
                      </span>{" "}
                      Official letters, memos, or communications (e.g., FOIA
                      responses).
                    </li>
                    <li>
                      <span
                        style={{ fontWeight: "bold" }}
                        className="comm-head-mobile-stl"
                      >
                        Records:
                      </span>{" "}
                      Contracts, grants, permits, or administrative records
                      (e.g., FEMA disaster relief contracts).
                    </li>
                    <li>
                      <span
                        style={{ fontWeight: "bold" }}
                        className="comm-head-mobile-stl"
                      >
                        Public Notices:
                      </span>{" "}
                      Announcements, such as proposed rules or meeting agendas
                      published in the Federal Register.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="Glossary-underline"></div>

          <div className="Glossary-card-Flex-containerNEW">
            <div className="Glossary-card-heading">
              <h1>B</h1>
            </div>
            <div className="Glossary-card-lastf1data">
              <div className="Glossary-inner-F1-score-flex">
                <div className="Glossary-inner-F1-heading">
                  <h3 className="agc-doc-mobile">BRE</h3>
                </div>
                <div className="Glossary-inner-F1-innerdata">
                  <p>Business Retention and Expansion</p>
                </div>
              </div>

              <div className="flex-alldaata">
                <div className="Glossary-card--heading">
                  <h3 className="agc-doc-mobile">Ballot Measure</h3>
                </div>
                <div className="JOI-Score-css">
                  <p>
                    A law, issue or topic placed on a statewide or municipal
                    ballot in the United States for voters to decide through an
                    election.
                  </p>

                  <ul className="glossary-items-points">
                    <li>
                      <span
                        style={{ fontWeight: "bold" }}
                        className="comm-head-mobile-stl"
                      >
                        Approved by Voters:
                      </span>{" "}
                      The ballot measure has been voted on in an election, and a
                      sufficient majority of voters (as required by
                      jurisdiction, typically a simple majority) approved it.
                      The measure is set to become law or take effect, pending
                      any final certification or legal challenges. For example,
                      a state proposition to raise taxes that passes with 55%
                      voter approval would be "Approved by Voters."
                    </li>
                    <li>
                      <span
                        style={{ fontWeight: "bold" }}
                        className="comm-head-mobile-stl"
                      >
                        Eligible for Ballot:
                      </span>{" "}
                      The ballot measure has met all legal and procedural
                      requirements to qualify for placement on a ballot in an
                      upcoming election. This often includes collecting enough
                      valid voter signatures (for citizen-initiated measures),
                      meeting filing deadlines, and complying with state or
                      local laws. The measure is not yet on the ballot but has
                      cleared hurdles to be considered for placement. For
                      instance, a petition with 500,000 verified signatures in a
                      state requiring 400,000 would be "Eligible for Ballot."
                    </li>
                    <li>
                      <span
                        style={{ fontWeight: "bold" }}
                        className="comm-head-mobile-stl"
                      >
                        Place on Ballot:
                      </span>{" "}
                      The ballot measure was voted on in an election but did not
                      receive enough votes to pass (e.g., failed to achieve a
                      simple majority or a required supermajority, depending on
                      the jurisdiction). The measure does not become law and is
                      considered defeated, though it could potentially be
                      reintroduced in a future election. For instance, a bond
                      measure requiring 66.7% approval but receiving only 60%
                      would be "Rejected by Voters."
                    </li>
                    <li>
                      <span
                        style={{ fontWeight: "bold" }}
                        className="comm-head-mobile-stl"
                      >
                        Rejected by Voters:
                      </span>{" "}
                      The ballot measure was voted on in an election but did not
                      receive enough votes to pass (e.g., failed to achieve a
                      simple majority or a required supermajority, depending on
                      the jurisdiction). The measure does not become law and is
                      considered defeated, though it could potentially be
                      reintroduced in a future election. For instance, a bond
                      measure requiring 66.7% approval but receiving only 60%
                      would be "Rejected by Voters."
                    </li>
                    <li>
                      <span
                        style={{ fontWeight: "bold" }}
                        className="comm-head-mobile-stl"
                      >
                        Removed from Ballot:
                      </span>{" "}
                      The ballot measure was initially eligible or placed on the
                      ballot but was subsequently withdrawn or disqualified
                      before the election. This could occur due to legal
                      challenges (e.g., a court ruling it unconstitutional),
                      procedural errors, withdrawal by proponents, or other
                      administrative actions. Voters do not get to vote on it.
                      For example, a proposition struck down by a state supreme
                      court for violating single-subject rules would be "Removed
                      from Ballot."
                    </li>
                    <li>
                      <span
                        style={{ fontWeight: "bold" }}
                        className="comm-head-mobile-stl"
                      >
                        Too Close to Call:
                      </span>{" "}
                      The ballot measure has been voted on, but the election
                      results are too close to determine a definitive outcome
                      based on initial vote counts. The margin of votes is
                      narrow enough that further counting (e.g., provisional or
                      mail-in ballots) or recounts are needed to confirm whether
                      the measure passed or failed. For example, a measure with
                      50.1% approval and 49.9% rejection with uncounted ballots
                      remaining might be "Too Close to Call."
                    </li>
                    <li>
                      <span
                        style={{ fontWeight: "bold" }}
                        className="comm-head-mobile-stl"
                      >
                        Unofficially Approved by Voters:
                      </span>{" "}
                      The ballot measure appears to have passed based on
                      preliminary election results, but the outcome is not yet
                      certified by election officials. This status reflects
                      early vote counts (e.g., from election night) showing
                      voter approval, but final results are pending due to
                      ongoing vote tabulation, verification, or potential
                      recounts. For example, a measure reported as passing with
                      52% on election night but awaiting mail-in ballot counts
                      would be "Unofficially Approved by Voters."
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="Glossary-underline"></div>

          <div className="Glossary-card-Flex-containerNEW">
            <div className="Glossary-card-heading">
              <h1>C</h1>
            </div>
            <div className="main-div">
              <div className="flex-alldaata">
                <div className="Glossary-card--heading">
                  <h3 className="agc-doc-mobile">Clickable Tiles</h3>
                </div>
                <div className="JOI-Score-css">
                  <p>
                    Interactive virtual elements on a screen that display data
                    and can be selected or clicked to access more information or
                    perform an action
                  </p>
                </div>
              </div>
              <div className="flex-alldaata">
                <div className="Glossary-card--heading">
                  <h3 className="agc-doc-mobile">Connection</h3>
                </div>
                <div className="JOI-Score-css">
                  <p>
                    A relationship in which a person at JobsOhio is linked or
                    associated with another person at a potential client
                    company, either directly or indirectly.
                  </p>
                </div>
                <div className="lastheadingdata">
                  <p>a.k.a. Network Graph</p>
                </div>
              </div>
              <div className="flex-alldaata">
                <div className="Glossary-card--heading"></div>
                <div className="JOI-Score-css">
                  <h4 className="agc-doc-mobile">
                    JOI provides several connection types, including:
                  </h4>
                  <p>
                    Company Connection <br />
                    Education Connection <br />
                    Email Connection <br />
                    Experience Connection <br />
                    LinkedIn <br /> Connection
                  </p>
                </div>
              </div>
              <div className="flex-alldaata">
                <div className="Glossary-card--heading">
                  <h3>
                    Company <br /> Connection
                  </h3>
                </div>
                <div className="JOI-Score-css">
                  <p>
                    A connection between two people who are currently employed
                    by the company
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="Glossary-underline"></div>

          <div className="Glossary-card-Flex-containerNEW">
            <div className="Glossary-card-heading">
              <h1>D</h1>
            </div>
            <div className="main-div">
              <div className="flex-alldaata">
                <div className="Glossary-card--heading">
                  <h3>Data Confidence Score</h3>
                </div>
                <div className="JOI-Score-css">
                  <p>
                    A quantitative measure that reflects the overall reliability
                    and trustworthiness of a dataset, considering multiple
                    factors (including, but not limited to, completeness, last
                    data refresh, as well as confidence in the data sources)
                  </p>
                </div>
              </div>
              <div className="flex-alldaata">
                <div className="Glossary-card--heading">
                  <h3>Data Enrich</h3>
                </div>
                <div className="JOI-Score-css">
                  <p>
                    The Data Enrich feature allows the user to submit a list of
                    organizations or prospects to enrich with data that is
                    either found within JOI or discovered through our data
                    curation process. Any organizations or prospects that are
                    new to JOI will be ingested into the tool and made available
                    to all users
                  </p>
                </div>
              </div>
              {/* <div className="flex-alldaata">
                <div className="Glossary-card--heading">
                  <h3>Data Enrichment</h3>
                </div>
                <div className="JOI-Score-css">
                  <p>
                    The process of combining first party data from internal
                    sources with third party data from external sources
                  </p>
                </div>
              </div> */}
              <div className="flex-alldaata">
                <div className="Glossary-card--heading">
                  <h3>Data Lake</h3>
                </div>
                <div className="JOI-Score-css">
                  <p>
                    A centralized repository designed to store, process, and
                    secure large amounts of structured, semi-structured, and
                    unstructured data
                  </p>
                </div>
              </div>
              <div className="flex-alldaata">
                <div className="Glossary-card--heading">
                  <h3>Data Sync</h3>
                </div>
                <div className="JOI-Score-css">
                  <p>
                    The most recent time when the data was refreshed, updated,
                    or synchronized between various sources to ensure
                    consistency and accuracy
                  </p>
                </div>
              </div>
              <div className="flex-alldaata">
                <div className="Glossary-card--heading">
                  <h3>Decision-maker</h3>
                </div>
                <div className="JOI-Score-css">
                  <p>
                    Key employees in target companies (Leads) who work to
                    determine the best solutions for their company to aid growth
                    and overall success
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="Glossary-underline"></div>

          <div className="Glossary-card-Flex-containerNEW">
            <div className="Glossary-card-heading">
              <h1>E</h1>
            </div>
            <div className="main-div">
              <div className="flex-alldaata">
                <div className="Glossary-card--heading">
                  <h3>Education</h3>
                </div>
                <div className="JOI-Score-css">
                  <p>
                    A connection between two people who attended the same
                    college or university
                  </p>
                </div>
              </div>
              <div className="flex-alldaata">
                <div className="Glossary-card--heading">
                  <h3>Email Connection</h3>
                </div>
                <div className="JOI-Score-css">
                  <p>
                    A connection on LinkedIn between an employee at JobsOhio and
                    another person via email
                  </p>
                </div>
              </div>
              <div className="flex-alldaata">
                <div className="Glossary-card--heading">
                  <h3>
                    {" "}
                    Experience <br />
                    Connection
                  </h3>
                </div>
                <div className="JOI-Score-css">
                  <p>
                    A connection between two people who were previously employed
                    by the same company at the same time
                  </p>
                </div>
              </div>

              <div className="flex-alldaata">
                <div className="Glossary-card--heading">
                  <h3>
                    {" "}
                    Executive <br />
                    Order
                  </h3>
                </div>
                <div className="JOI-Score-css">
                  <p>
                    A directive issued by the President of the United States
                    (or, in state contexts, a governor) that manages operations
                    of the federal or state government, implements policies, or
                    directs agencies to take specific actions. It has the force
                    of law but does not require legislative approval.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="Glossary-underline"></div>

          <div className="Glossary-card-Flex-containerNEW">
            <div className="Glossary-card-heading">
              <h1>F</h1>
            </div>
            <div className="Glossary-card-lastf1data">
              <div className="Glossary-inner-F1-score-flex">
                <div className="Glossary-inner-F1-heading">
                  <h3>F1 Score</h3>
                </div>
                <div className="Glossary-inner-F1-innerdata">
                  <p>
                    Machine learning evaluation metric that measures a model's
                    accuracy.  Integrates precision and recall into a single
                    metric to gain a better understanding of model performance
                  </p>
                </div>
              </div>
              <div className="Glossary-inner-F1-score-flex">
                <div className="Glossary-inner-F1-heading">
                  <h3>Former Employee Badge</h3>
                </div>
                <div className="Glossary-inner-F1-innerdata">
                  <p>
                    Visual symbol used to mark individuals who no longer work at
                    a company, helping distinguish them in directories and
                    communications
                  </p>
                </div>
              </div>
              <div className="Glossary-inner-F1-score-flex">
                <div className="Glossary-inner-F1-heading">
                  <h3>
                    Full job title <br />
                    vs <br />
                    Grouping job title
                  </h3>
                </div>
                <div className="Glossary-inner-F1-innerdata">
                  <p>
                    Using full job titles on a Prospect Detail page or when
                    hovering over a name icon on the AI Prospect page displays
                    the specific role of an individual, providing clear and
                    precise information about their position. In contrast,
                    grouping job titles into buckets organizes similar roles
                    under broader categories, offering a more generalized view
                    but potentially reducing detail and clarity about the exact
                    role of each prospect
                  </p>
                </div>
              </div>
              <div className="Glossary-inner-F1-score-flex">
                <div className="Glossary-inner-F1-heading">
                  <h3>Funding</h3>
                </div>
                <div className="Glossary-inner-F1-innerdata">
                  <p>
                    Funding is the money that a company raises or receives from
                    various investors during defined funding stages (pre-seed,
                    seed and venture capital)
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="Glossary-underline"></div>

          <div className="Glossary-card-Flex-container">
            <div className="Glossary-card-heading">
              <h1>G</h1>
            </div>
            <div className="graph-glossary-mobile">
              <div className="Glossary-card-sub-heading">
                <h3 className="agc-doc-mobile">Graph</h3>
              </div>
              <div className="Glossary-card-last">
                <p>
                  A graph is a collection of nodes (vertices) and edges. The
                  edges connect pairs of nodes, representing relationships or
                  connections between them.
                </p>
              </div>
              <div className="lastConnection">
                <p>a.k.a. Connection or Network Connection or Network Graph</p>
              </div>
            </div>
          </div>
          <div className="Glossary-underline"></div>

          <div className="Glossary-card-Flex-container">
            <div className="Glossary-card-heading">
              <h1>H</h1>
            </div>
            <div className="Glossary-card-sub-heading">
              <h3></h3>
            </div>
            <div className="Glossary-card-last">
              <p></p>
            </div>
          </div>
          <div className="Glossary-underline"></div>

          <div className="Glossary-card-Flex-containerNEW">
            <div className="Glossary-card-heading">
              <h1>I</h1>
            </div>
            <div className="Glossary-card-lastf1data">
              <div className="Glossary-inner-F1-score-flex">
                <div className="Glossary-inner-F1-heading">
                  <h3>Industry</h3>
                </div>
                <div className="Glossary-inner-F1-innerdata">
                  <p>
                    A branch of an economy that produces a closely related set
                    of raw materials, goods, or services
                  </p>
                </div>
              </div>
              <div className="Glossary-inner-F1-score-flex">
                <div className="Glossary-inner-F1-heading">
                  <h3>IPO Status</h3>
                </div>
                <div className="Glossary-inner-F1-innerdata">
                  <p>
                    Describes the position of a company's initial public
                    offering (IPO) with respect to how many committed investors
                    it has before the actual IPO.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="Glossary-underline"></div>

          <div className="Glossary-card-Flex-containerNEW">
            <div className="Glossary-card-heading">
              <h1>J</h1>
            </div>
            <div className="main-div">
              <div className="flex-alldaata">
                <div className="Glossary-card--heading">
                  <h3>JOI-Score</h3>
                </div>
                <div className="JOI-Score-css">
                  <p>
                    The JOI-Score is a measure of suitability, ranging from 0 to
                    100, that provides users with information on whether a
                    company is positioned for growth. This score is determined
                    by triggers identified by the BD NA team. A higher JOI-Score
                    indicates that the company is prepared to expand and
                    fulfills the criteria for growth
                  </p>
                </div>
              </div>
              <div className="flex-alldaata">
                <div className="Glossary-card--heading">
                  <h3>JOI-Strength</h3>
                </div>
                <div className="JOI-Score-css">
                  <p>
                    The JOI-Strength Score is a quantifiable measure developed
                    to assess the strength of connection between two
                    individuals, leveraging a sophisticated AI model. This model
                    intricately analyzes various dimensions of interpersonal
                    connections and provides a strength score between 0-100. The
                    higher the score, the stronger the connection.
                  </p>
                </div>
              </div>
              <div className="flex-alldaata">
                <div className="Glossary-card--heading">
                  <h3>JOSF</h3>
                </div>
                <div className="JOI-Score-css">
                  <p>JobsOhio Salesforce </p>
                </div>
              </div>
            </div>
          </div>

          <div className="Glossary-underline"></div>

          <div className="Glossary-card-Flex-container">
            <div className="Glossary-card-heading">
              <h1>K</h1>
            </div>
            <div className="Glossary-card-sub-heading">
              <h3></h3>
            </div>
            <div className="Glossary-card-last">
              <p> </p>
            </div>
          </div>

          <div className="Glossary-underline"></div>

          <div className="Glossary-card-Flex-containerNEW">
            <div className="Glossary-card-heading">
              <h1>L</h1>
            </div>
            <div className="main-div">
              <div className="flex-alldaata">
                <div className="Glossary-card--heading">
                  <h3>
                    Last Funding <br /> Date
                  </h3>
                </div>
                <div className="JOI-Score-css">
                  <p>The date of the last funding round</p>
                </div>
              </div>
              <div className="flex-alldaata">
                <div className="Glossary-card--heading">
                  <h3>
                    Last Funding <br /> Total
                  </h3>
                </div>
                <div className="JOI-Score-css">
                  <p>
                    The total value of the last funding round, expressed in USD
                  </p>
                </div>
              </div>
              <div className="flex-alldaata">
                <div className="Glossary-card--heading">
                  <h3>
                    Last Funding <br />
                    Type
                  </h3>
                </div>
                <div className="JOI-Score-css">
                  <p>
                    The last funding type is indicative of where the company is
                    in the funding process, which is divided into a series of
                    phases. This begins with the pre-seed and seed phases,
                    followed by the venture capital phase (series A funding
                    onwards).
                  </p>
                </div>
              </div>
              <div className="flex-alldaata">
                <div className="Glossary-card--heading">
                  <h3>
                    Last Interaction <br />
                    Date
                  </h3>
                </div>
                <div className="JOI-Score-css">
                  <p>
                    The last time two people interacted with one another, refers
                    to the most recent moment or instance when two individuals
                    communicated or engaged with each other
                  </p>
                </div>
              </div>

              <div className="flex-alldaata">
                <div className="Glossary-card--heading">
                  <h3>Lead </h3>
                </div>
                <div className="JOI-Score-css">
                  <p>
                    Potential client companies that have been identified as
                    having the highest chance of success based on JOI algorithms
                  </p>
                </div>
                <div className="JOI-suspect">
                  <p>a.k.a., suspect, prospect, target</p>
                </div>
              </div>

              <div className="flex-alldaata">
                <div className="Glossary-card--heading">
                  <h3>LinkedIn Connection</h3>
                </div>
                <div className="JOI-Score-css">
                  <p>
                    A connection between an employee at JobsOhio and another
                    person via LinkedIn
                  </p>
                </div>
              </div>

              <div className="flex-alldaata">
                <div className="Glossary-card--heading">
                  <h3>Legislation</h3>
                </div>
                <div className="JOI-Score-css">
                  <p>
                    The preparation and enactment of laws by a legislative body
                    through its lawmaking process.
                  </p>
                  <ul className="glossary-items-points">
                    <li>
                      <span style={{ fontWeight: "bold" }}>Adopted</span>:
                      Legislation that has been officially approved and accepted
                      by the relevant legislative body.
                    </li>
                    <li>
                      <span style={{ fontWeight: "bold" }}>Enacted</span>:
                      Legislation that has been formally approved and passed,
                      becoming a binding legal rule.
                    </li>
                    <li>
                      <span style={{ fontWeight: "bold" }}>Failed</span>: The
                      proposed bill or resolution did not pass through the
                      legislative process to become law.
                    </li>
                    <li>
                      <span style={{ fontWeight: "bold" }}>
                        Failed-Adjourned
                      </span>
                      : The bill did not pass during the legislative session and
                      the session ended (adjourned) before the bill could
                      complete the legislative process. This is a specific type
                      of failure where the bill essentially "dies" due to the
                      legislature running out of time.
                    </li>
                    <li>
                      <span style={{ fontWeight: "bold" }}>
                        Override Pending
                      </span>
                      : The bill has been passed by the legislature but was
                      vetoed by the executive (e.g., governor or president), and
                      the legislature is now considering whether to override the
                      veto.
                    </li>
                    <li>
                      <span style={{ fontWeight: "bold" }}>Pending</span>: The
                      bill or resolution is still active in the legislative
                      process and has not yet reached a final outcome.
                    </li>
                    <li>
                      <span style={{ fontWeight: "bold" }}>
                        Pending-Carryover
                      </span>
                      : The bill is still active in the legislative process and
                      has been carried over from one session to the next within
                      the same legislative term, typically in a bicameral
                      legislature with biennial or multi-year terms.
                    </li>
                    <li>
                      <span style={{ fontWeight: "bold" }}>To Congress</span>:
                      Bill is actively under consideration in the U.S. Congress,
                      possibly having moved from a committee to the floor, from
                      one chamber to the other, or awaiting final steps like a
                      vote or conference committee.
                    </li>
                    <li>
                      <span style={{ fontWeight: "bold" }}>To Governor</span>:
                      The bill has passed both chambers of the legislature
                      (e.g., House and Senate in a state legislature) and has
                      been sent to the governor for final action.
                    </li>
                    <li>
                      <span style={{ fontWeight: "bold" }}>To Mayor</span>: A
                      bill, ordinance, or resolution has been passed by the
                      local legislative body (e.g., city council, board of
                      aldermen, or municipal assembly) and has been sent to the
                      mayor for final action. This status is specific to
                      municipal governments where the mayor has executive
                      authority over legislation.
                    </li>
                    <li>
                      <span style={{ fontWeight: "bold" }}>To President</span>:
                      A bill has passed both chambers of the U.S. Congress (the
                      House of Representatives and the Senate) and has been sent
                      to the President of the United States for final action.
                      This is a critical stage in the federal legislative
                      process.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="Glossary-underline"></div>

          {ShowMoreData && (
            <>
              <div className="Glossary-card-Flex-container">
                <div className="Glossary-card-heading">
                  <h1>M</h1>
                </div>
                <div className="Glossary-card-sub-heading"></div>
                <div className="Glossary-card-last"></div>
              </div>
              <div className="Glossary-underline"></div>

              <div className="Glossary-card-Flex-container">
                <div className="Glossary-card-heading">
                  <h1>N</h1>
                </div>
                <div className="graph-glossary-mobile">
                  <div className="Glossary-card-sub-heading">
                    <h3 className="agc-doc-mobile">Node</h3>
                  </div>
                  <div className="Glossary-card-last">
                    <p>
                      A node, also known as a vertex, is a fundamental unit in a
                      graph
                    </p>
                  </div>
                </div>
              </div>
              <div className="Glossary-underline"></div>

              <div className="Glossary-card-Flex-container">
                <div className="Glossary-card-heading">
                  <h1>O</h1>
                </div>
                <div className="Glossary-card-sub-heading">
                  <h3></h3>
                </div>
                <div className="Glossary-card-last">
                  <p> </p>
                </div>
              </div>
              <div className="Glossary-underline"></div>

              <div className="Glossary-card-Flex-containerNEW">
                <div className="Glossary-card-heading">
                  <h1>P</h1>
                </div>
                <div className="Glossary-card-lastf1data">
                  <div className="Glossary-inner-F1-score-flex">
                    <div className="Glossary-inner-F1-heading">
                      <h3>Path</h3>
                    </div>
                    <div className="Glossary-inner-F1-innerdata">
                      <p>
                        The best connection between decision-makers in these
                        companies via JobsOhio
                      </p>
                    </div>
                  </div>
                  <div className="Glossary-inner-F1-score-flex">
                    <div className="Glossary-inner-F1-heading">
                      <h3>Precision</h3>
                    </div>
                    <div className="Glossary-inner-F1-innerdata">
                      <p>
                        Precision answers the question “How often are the
                        positive predictions made by the model correct?
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="Glossary-underline"></div>

              <div className="Glossary-card-Flex-container">
                <div className="Glossary-card-heading">
                  <h1>Q</h1>
                </div>
                <div className="Glossary-card-sub-heading">
                  <h3></h3>
                </div>
                <div className="Glossary-card-last">
                  <p> </p>
                </div>
              </div>
              <div className="Glossary-underline"></div>

              <div className="Glossary-card-Flex-containerNEW">
                <div className="Glossary-card-heading">
                  <h1>R</h1>
                </div>
                <div className="Glossary-card-lastf1data">
                  <div className="Glossary-inner-F1-score-flex">
                    <div className="Glossary-inner-F1-heading">
                      <h3>Recall</h3>
                    </div>
                    <div className="Glossary-inner-F1-innerdata">
                      <p>
                        Recall tells us how effective the model is at
                        identifying positive classifications
                      </p>
                    </div>
                  </div>
                  <div className="Glossary-inner-F1-score-flex">
                    <div className="Glossary-inner-F1-heading">
                      <h3>Revenue Range</h3>
                    </div>
                    <div className="Glossary-inner-F1-innerdata">
                      <p>
                        Revenue is the amount of money generated from normal
                        business operations. Revenue ranges are used to
                        categorize the revenue of companies into specific high
                        and low ranges.
                      </p>
                    </div>
                  </div>

                  <div className="Glossary-inner-F1-score-flex">
                    <div className="Glossary-inner-F1-heading">
                      <h3>Regulation</h3>
                    </div>
                    <div className="Glossary-inner-F1-innerdata">
                      <p>
                        Refers to rules and standards created by government
                        agencies to implement and enforce laws passed by the
                        legislature. These regulations, while not laws
                        themselves, have the force of law and are necessary for
                        putting legislation into practice. They often detail the
                        specific procedures and requirements for compliance with
                        the overarching legislation.
                      </p>
                      <ul className="glossary-items-points">
                        <li>
                          <span style={{ fontWeight: "bold" }}>Adopted</span>:
                          Refers to a rule or standard that has been officially
                          accepted and approved by a governing body, such as a
                          government agency or a legislative body, and made
                          legally binding. This process typically involves
                          drafting, public notice, hearings, and a final
                          approval.
                        </li>
                        <li>
                          <span style={{ fontWeight: "bold" }}>Pending</span>:
                          Refers to a rule or legal standard that has been
                          proposed or drafted by an agency or legislative body,
                          but which has not yet been finalized or enacted. This
                          means it's in a state of being considered, debated,
                          and possibly amended before it becomes effective.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="Glossary-underline"></div>

              <div className="Glossary-card-Flex-containerNEW">
                <div className="Glossary-card-heading">
                  <h1>S</h1>
                </div>
                <div className="main-div">
                  <div className="flex-alldaata">
                    <div className="Glossary-card--heading">
                      <h3>Salesforce Status</h3>
                    </div>
                    <div className="JOI-Score-css">
                      <p>
                        Represents the current stage of a prospect's journey in
                        the Salesforce platform, providing valuable insights
                        into their buyer's lifecycle.
                      </p>
                    </div>
                  </div>
                  <div className="flex-alldaata">
                    <div className="Glossary-card--heading">
                      <h3>Sector </h3>
                    </div>
                    <div className="JOI-Score-css">
                      <p>
                        A general segment of the economy that contains similar
                        industries
                      </p>
                    </div>
                  </div>
                  <div className="flex-alldaata">
                    <div className="Glossary-card--heading">
                      <h3>
                        Social Media <br /> Handles{" "}
                      </h3>
                    </div>
                    <div className="JOI-Score-css">
                      <p>
                        Unique usernames or identifiers used to represent an
                        individual or organization on social media platforms.
                        When available, they will be present on the Prospect
                        Detail page
                      </p>
                    </div>
                  </div>
                  <div className="flex-alldaata">
                    <div className="Glossary-card--heading">
                      <h3>Specificity</h3>
                    </div>
                    <div className="JOI-Score-css">
                      <p>
                        <p>
                          Specificity tells us how effective the model is at
                          identifying negative classifications
                        </p>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="Glossary-underline"></div>

              <div className="Glossary-card-Flex-container">
                <div className="Glossary-card-heading">
                  <h1>T</h1>
                </div>
                <div className="graph-glossary-mobile">
                  <div className="Glossary-card-sub-heading">
                    <h3 className="agc-doc-mobile">Trigger</h3>
                  </div>
                  <div className="Glossary-card-last">
                    <p>
                      A "trigger" in a lead generation system is a predefined
                      criterion that helps identify potential leads by
                      evaluating key characteristics of companies. Triggers
                      enable targeted and efficient lead identification by
                      signaling which companies match the ideal customer profile
                      or show readiness for engagement.
                    </p>
                  </div>
                </div>
              </div>
              <div className="Glossary-underline"></div>

              <div className="Glossary-card-Flex-container">
                <div className="Glossary-card-heading">
                  <h1>U</h1>
                </div>
                <div className="Glossary-card-sub-heading">
                  <h3></h3>
                </div>
                <div className="Glossary-card-last">
                  <p> </p>
                </div>
              </div>
              <div className="Glossary-underline"></div>

              <div className="Glossary-card-Flex-container">
                <div className="Glossary-card-heading">
                  <h1>V</h1>
                </div>
                <div className="Glossary-card-sub-heading">
                  <h3></h3>
                </div>
                <div className="Glossary-card-last">
                  <p> </p>
                </div>
              </div>
              <div className="Glossary-underline"></div>

              <div className="Glossary-card-Flex-container">
                <div className="Glossary-card-heading">
                  <h1>W</h1>
                </div>
                <div className="Glossary-card-sub-heading">
                  <h3></h3>
                </div>
                <div className="Glossary-card-last">
                  <p> </p>
                </div>
              </div>
              <div className="Glossary-underline"></div>

              <div className="Glossary-card-Flex-container">
                <div className="Glossary-card-heading">
                  <h1>X</h1>
                </div>
                <div className="Glossary-card-sub-heading">
                  <h3></h3>
                </div>
                <div className="Glossary-card-last">
                  <p> </p>
                </div>
              </div>
              <div className="Glossary-underline"></div>

              <div className="Glossary-card-Flex-container">
                <div className="Glossary-card-heading">
                  <h1>Y</h1>
                </div>
                <div className="Glossary-card-sub-heading">
                  <h3></h3>
                </div>
                <div className="Glossary-card-last">
                  <p> </p>
                </div>
              </div>
              <div className="Glossary-underline"></div>

              <div className="Glossary-card-Flex-container">
                <div className="Glossary-card-heading">
                  <h1>Z</h1>
                </div>
                <div className="Glossary-card-sub-heading">
                  <h3></h3>
                </div>
                <div className="Glossary-card-last">
                  <p> </p>
                </div>
              </div>
            </>
          )}

          <div className="Glossary-underline"></div>
          <div className="Glossary-button-container">
            {!buttonHidden && (
              <Stack spacing={2} direction="row">
                <Button onClick={HandelshowMore} variant="outlined">
                  Load More
                </Button>
              </Stack>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
